import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import Alert from 'antd/lib/alert';

@translate()
export default class CardPaymentResult extends Component {

   
    render() {
        const { result, t } = this.props;

        if (result == null) {
        return <div />;
        }

        return (
        <Row around="xs">
            <Col xs={12}>
            {result === true && (
                <Alert message={t('Platba bola úspešne spracovaná. Zmeny vo vašom účte sa prejavia o pár minút.')} type="success" showIcon description={'\t'}  />
            )}
            {result === false && (
                <Alert message={t('Pri platení sa vyskytla chyba, prosím, zopakujte platbu')} type="error" showIcon description={'\t'}  />
            )}
            
            </Col>
        </Row>
        );
    }
}   

    


// WEBPACK FOOTER //
// ./src/features/dashboard/components/CardPaymentResult.js